import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import throttle from 'lodash/throttle';

import Button from 'src/components/Button';
import LastBillOrders from 'src/components/LastBillOrders';

import { ROUTE_TYPES_VALUES } from 'src/modules/Restaurant';

import theme from 'src/styles/components/LastBillButton.module.scss';

const LastBillButton = ({
    emitMessage,
    className,
    context,
    fetchLastBill,
    lastBill,
    sessionError
}) => {
    const intl = useIntl();

    const shouldShowLastBillButton = context
        && (
            context.routeType === ROUTE_TYPES_VALUES.BILL_WAIT
            || context.routeType === ROUTE_TYPES_VALUES.MENU
            || sessionError
        );

    useEffect(() => {
        if (shouldShowLastBillButton) {
            const { restaurantId } = context;

            fetchLastBill({ restaurantId });
        }
    }, [shouldShowLastBillButton, context]);

    const showLastBillButton = useCallback(throttle(() => {
        emitMessage({
            type: 'small',
            title: intl.formatMessage({ id: 'App.yourLastBill' }),
            className: theme.modal,
            message: (
                <LastBillOrders />
            ),
            isEscKeyDownEnabled: true,
            isDismissButtonEnabled: true,
            overflow: true
        });
    }, 2000), []);

    if (!shouldShowLastBillButton || !lastBill) {
        return null;
    }

    return (
        <div className={theme.container}>
            <Button
              className={classnames(className, theme.button)}
              icon="icon-bill"
              onClick={showLastBillButton}
              primary
              floating
              inverse
            />
        </div>
    );
};

LastBillButton.propTypes = {
    emitMessage: PropTypes.func.isRequired,
    className: PropTypes.string,
    context: PropTypes.shape({
        restaurantId: PropTypes.string,
        tableId: PropTypes.string,
        routeType: PropTypes.number
    }),
    sessionError: PropTypes.bool,
    fetchLastBill: PropTypes.func.isRequired,
    lastBill: PropTypes.object
};

export default LastBillButton;
